import { render, staticRenderFns } from "./CancelReason.vue?vue&type=template&id=ebbc1ae4"
import script from "./CancelReason.js?vue&type=script&lang=js&external"
export * from "./CancelReason.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports